// extracted by mini-css-extract-plugin
module.exports = {"container":"TemplateSwitch_container__38MFK","back":"TemplateSwitch_back__1iCSi"};